import { render, staticRenderFns } from "./RetentionMessage.vue?vue&type=template&id=53dfc178&scoped=true&"
import script from "./RetentionMessage.vue?vue&type=script&lang=js&"
export * from "./RetentionMessage.vue?vue&type=script&lang=js&"
import style0 from "./RetentionMessage.vue?vue&type=style&index=0&id=53dfc178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dfc178",
  null
  
)

export default component.exports